import { Circ, Expo, TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import * as PIXI from "pixi.js";
import {Ease} from "../core/Animatable";
import {Container} from "../core/Container";
import {array} from "../core/Reflection";
import {Sprite} from "../core/Sprite";
import { Button, OutlinedButton } from "../gameobjects/Button";
import {AbstractGameState} from "./AbstractGameState";

import { Application } from "../Application";
import * as VO from "../data/VO";
import { Abby } from "../gameobjects/Abby";
import { Grover } from "../gameobjects/Grover";
import {PlanterCustomizeIntroLayout} from "../layout/PlanterCustomizeIntroLayout";
import { PlanterPlantingIntroLayout } from "../layout/PlanterPlantingIntroLayout";
import { CaptionManager } from "../managers/CaptionManager";
import { PlanterCustomizeScreen } from "./PlanterCustomizeScreen";
import { PlanterPlantingScreen } from "./PlanterPlantingScreen";

export class PlanterPlantingIntroScreen extends AbstractGameState {

    public static readonly NAME = "PlanterPlantingIntroScreen";
    public static visited: boolean = false;

    public readonly bg = this.addChild(new Sprite());
    public readonly abby = this.addChild(new Abby());
    public readonly grover = this.addChild(new Grover());
    public readonly skipButton = this.addChild(new Button());
    public readonly homeButton = this.addChild(new OutlinedButton());
    protected analyticsScreenName: string = "6b Planter Party_Plant Screen";
    protected analyticsRoundName = "Planter Party";

    public init(pSize: PIXI.Point, pData: {}) {
        PlanterPlantingIntroLayout.call(this);

        this.skipButton.onClick.add(() => {
            PlanterPlantingIntroScreen.visited = true;
            this.gotoNextState(PlanterPlantingScreen.NAME);
        });
        this.homeButton.onClick.add(() => {
            this.trackEvent("gameMenuClick",
                {label: `MenuButton_Home_ScreenName_${this.analyticsScreenName}`},
            );
            this.gotoNextState("MainMenu");
        });
        this.homeButton.clickSfx = "buttonclick";
        this.skipButton.clickSfx = "buttonclick";

        this.skipButton.visible = false;

        super.init(pSize);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);
        const bgm = HLF.Application.instance.audio.getAudioTrack("planter_party_loop", HLF.AudioCategory.BGM) ?? HLF.Application.instance.audio.createAudioTrack("planter_party_loop", HLF.AudioCategory.BGM);
        if (bgm.isPlaying() === false) {
            bgm.setLooped(true);
            bgm.play();
        }
        Application.instance.voiceover.playVO([VO.PP_PLANTINGINTRO01, ...VO.PP_PLANTINGINTRO02], () => {
            PlanterPlantingIntroScreen.visited = true;
            this.gotoNextState(PlanterPlantingScreen.NAME);
        });
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
        this.position.set((pSize.x - 1024) / 2, 0);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
        this.abby.update(pDeltaTime);
        this.grover.update(pDeltaTime);
    }
}
